import { BarcodeFormat, DecodeHintType } from '@zxing/library';

/** Strip whitespace and keep only digits for retail barcodes when applicable. */
export function normalizeBarcodeValue(raw: string): string {
  const trimmed = raw.trim();
  if (/^[\d\s-]+$/.test(trimmed)) {
    return trimmed.replace(/[\s-]/g, '');
  }
  return trimmed;
}

export const RETAIL_BARCODE_FORMATS: BarcodeFormat[] = [
  BarcodeFormat.EAN_13,
  BarcodeFormat.EAN_8,
  BarcodeFormat.UPC_A,
  BarcodeFormat.UPC_E,
  BarcodeFormat.CODE_128,
  BarcodeFormat.CODE_39,
  BarcodeFormat.ITF,
  BarcodeFormat.CODABAR,
];

export function createRetailBarcodeHints(): Map<DecodeHintType, unknown> {
  return new Map<DecodeHintType, unknown>([
    [DecodeHintType.POSSIBLE_FORMATS, RETAIL_BARCODE_FORMATS],
    [DecodeHintType.TRY_HARDER, true],
  ]);
}

/** Short success tone — typical handheld scanner feedback. */
export function playBarcodeScanBeep(): void {
  try {
    const AudioCtx =
      window.AudioContext ||
      (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AudioCtx) return;

    const ctx = new AudioCtx();
    const run = (): void => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.connect(gain);
      gain.connect(ctx.destination);

      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(1200, ctx.currentTime);
      gain.gain.setValueAtTime(0.2, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.15);

      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.15);
      oscillator.onended = () => {
        void ctx.close();
      };
    };

    if (ctx.state === 'suspended') {
      void ctx.resume().then(run);
    } else {
      run();
    }
  } catch {
    // Audio may be blocked by browser policy — scanning still succeeds.
  }
}
